import { render } from "./Tooltip.vue?vue&type=template&id=6f017dfa&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=6f017dfa&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-6f017dfa"

export default script